import React from "react";
import styled from "styled-components";

const CardStyled = styled.div`
  background-color: #fffcf6;
  border-radius: 10px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  min-width: 300px;

  @media (min-width: 768px) {
    padding: 40px;
    width: 80%;
    max-width: 700px;
    min-width: 500px;
  }
`;

const Card = ({ children }) => {
  return <CardStyled>{children}</CardStyled>;
};

export default Card;
